module.exports = __webpack_public_path__ + "static/media/vmm-education_logo.973bf67b.jpg";